import { type ShopSections } from "@src/api";
import { type MoneymapItemWithTitle } from './moneymap';

export const sectionListToMapMoneymap = (section_list: ShopSections[]) => {
  return section_list.reduce<Partial<Record<ShopSections, MoneymapItemWithTitle>>>((acc, cur) => {
    acc[cur] = {
      zone_id: 'not_zone_id',
      records_total: 0,
      amount_total: '0',
      quantity_total: 0,
      title: cur,
      is_link: true,
      is_zone: true
    };

    return acc;
  }, {});
};